import { useCallback } from 'react'

import { useUnit } from 'effector-react'

import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { $finishedPullingSentMedia } from '@/models/chattingUI/media.ts'
import { openDialog } from '@/models/dialogs.ts'
import type { PpvStatistics } from '@/modules/chatting/types'

import OpenInNewIcon from '../../../../icons/open-in-new.svg'
import PPVStatsIcon from '../../../../icons/ppv-stats.svg'
import { IconButton } from '../../../components/icon-button'
import { getPPVStatistics } from './utils'

interface Props {
  data: PpvStatistics
}

export const PPVStats = ({ data }: Props) => {
  const statistics = getPPVStatistics(data)
  const finishedPullingSentMedia = useUnit($finishedPullingSentMedia)
  const handlePPVTimelineDialogOpen = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.PPV_TIMELINE,
    })
  }, [])

  return (
    <div className="space-y-4 rounded-md bg-card p-3">
      <div className="flex items-center justify-between gap-2 rounded-md bg-secondary-50 p-2 text-title dark:bg-secondary-600">
        <div className="flex items-center gap-2">
          <PPVStatsIcon />
          <p className="flex-1 text-sm font-bold">PPV Stats</p>
        </div>
        <IconButton
          tooltip="Open detailed statistics"
          icon={OpenInNewIcon}
          onClick={handlePPVTimelineDialogOpen}
          className="text-primary-500"
          disabled={!finishedPullingSentMedia}
        />
      </div>
      <div className="space-y-2">
        {statistics.map((statistic, index) => (
          <div
            key={index}
            className="flex items-center gap-2 text-sm"
          >
            <div className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-50 dark:bg-primary-900">
              <statistic.icon className="text-primary-500" />
            </div>
            <p>{statistic.label}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
